import { atom } from 'recoil'

export const modalDeleteState = atom({
  key: 'recipientsBounceModalDeleteState',
  default: {
    show: false,
    items: [],
  },
})
